import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Register from './views/Register.vue'
import Front from './views/Front.vue'
import FrontNew from './views/FrontNew.vue'

import Languagecode from './views/Languagecode.vue'


import RegisterOption from './views/RegisterOption.vue'
import BusinessRegister from './views/BusinessRegister.vue'
import Agent from './views/Agent.vue'
import Dashboard from './views/admin/Dashboard.vue'
import CreateBusiness from './views/admin/CreateBusiness.vue'
import BusinessList from './views/admin/BusinessList.vue'
import BusinessListNew from './views/admin/BusinessListNew.vue'
import EditBusiness from './views/admin/EditBusiness.vue'
import ChangePassword from './views/admin/ChangePassword.vue'




import NewChangePassword from './views/NewChangePassword.vue'
import EditProfile from './views/admin/EditProfile.vue'
import Tags from './views/Tags.vue'
import ThankYou from './views/ThankYouReport.vue'
import store from './store'

import Business from './views/Business.vue'
import Businessdashboard from './views/admin/Businessdashboard.vue'
// import createDepartment from './views/admin/CreateDepartment.vue'
// import departmentList from './views/admin/DepartmentList.vue'

import CreateBusinessNew from './views/admin/CreateBusinessNew.vue'
import CreateBusinessDetail from './views/admin/CreateBusinessDetail.vue'
import order from './views/order.vue'
import employeelist from './views/admin/EmployeeList.vue'

import creatediet from './views/admin/createDiet.vue'
import dietlist from './views/admin/dietList.vue'
import editdiet from './views/admin/editDiet.vue'
import creatmeat from './views/admin/createmeat.vue'
import meatlist from './views/admin/meatList.vue'
import meatedit from './views/admin/meatEdit.vue'

import itemlist from './views/admin/itemlist.vue'
import createitem from './views/admin/CreateItem.vue'
import departmentlist from './views/admin/DepartmentList.vue'
import createdepartment from './views/admin/CreateDepartment.vue'
import createemployee from './views/admin/CreateEmployee.vue'
import editemployee from './views/admin/EditEmployee.vue'
import editdepartment from './views/admin/EditDepartment.vue'
import edititem from './views/admin/editItem.vue'
import drinkitemlist from './views/admin/DrinkItemList.vue'
import createdrinkitem from './views/admin/CreateDrinkItem.vue'
import editdrinkitem from './views/admin/EditDrinkItem.vue'
import CreateAgent from './views/admin/CreateAgent.vue'
import AgentList from './views/admin/AgentListNew.vue'
import EditAgent from './views/admin/EditAgent.vue'
import createevent from './views/admin/CreateEvent.vue'
import eventlist from './views/admin/EventList.vue'
import editevent from './views/admin/EditEvent.vue'
import TagsNew from './views/TagsNew.vue'

import businessDetails from './views/businessDetails.vue'
import businesslove from './views/businesslove.vue'

import events from './views/events.vue'

import food from './views/food.vue'

import drink from './views/drink.vue'

import retailitem from './views/retailitem.vue'


import changepass from './views/changepass.vue'


import eventdetails from './views/EventDetails.vue'

import teams from './views/teams.vue'

import teamdetails from './views/teamdetails.vue'

import bDetails from './views/bDetails.vue'

//import createretailitem from './views/admin/createretailitem.vue'

//import retailitemlist from './views/admin/retailitemlist.vue'
//import editretailitem from './views/admin/editretailitem.vue'


import tagslist from './views/admin/tagslist.vue'

import coronasurvey from './views/coronasurvey.vue'

import coronafeedback from './views/coronafeedback.vue'

import health from './views/health.vue'

import emergency from './views/emergency.vue'

import symptoms from './views/symptoms.vue'

import healthadvice from './views/healthadvice.vue'

import BusinessHome from './views/businesshome.vue'

import BusinessNewDashboard from './views/businessnewdashboard.vue'

import DashboardBusiness from './views/dashboardbusiness.vue'

import AppHelp from './views/apphelp.vue'

import UserDashboard from './views/userdashboard.vue'

import UpdateBusiness from './views/updatebusiness.vue'

import businessstatics from './views/businessstatics.vue'

import DrinkDragDropList from './views/drinkdragdroplist.vue'


import BusinessFoodList from './views/businessfoodlist.vue'

import BusinessFoodItemList from './views/businessfooditemlist.vue'

import CreateRetailItem from './views/createretailitem.vue' 

import CreateEventCategory from './views/CreateEventCategory.vue'

import EventCategoryList from './views/eventcategorylist.vue'

import EditEventCategory from './views/editeventcategory.vue'

import CreateCategory from './views/createcategory.vue'

import EditCategory from './views/editcategory.vue'

import EditType from './views/edittype.vue'


import CategoryList from './views/categorylist.vue'

import addEvent from './views/createevent.vue'

import eventLists from './views/eventLists.vue'

import updateevent from './views/EditEvent.vue'

import addEmployee from './views/CreateEmployee.vue'

import employeeLists from './views/EmployeeList.vue'

import addDepartment from './views/CreateDepartment.vue'

import departmentlists from './views/DepartmentList.vue'

import updatedepartment from './views/EditDepartment.vue'

import updateemployee from './views/EditEmployee.vue'


import RetailItemlist from './views/retailitemlist.vue' 

import Retaillist from './views/retaillist.vue'

import EditRetailItem from './views/editretailitem.vue'

import CreateFoodItem from './views/createfooditem.vue' 

import fooditemdetails from './views/fooditemdetails.vue'

import createcourse from './views/createcourse.vue'

import createtype from './views/createtype.vue'

import courselist from './views/courselist.vue'

import TypeList from './views/typelist.vue'

import editcourse from './views/editcourse.vue'

import CreatebusinessdrinkItem from './views/createbusinessdrinkitem.vue'

// import DrinkComponent from './components/DrinkComponent.vue'

import EditFoodItem from './views/editfooditem.vue'

import EditBusinessDrinkItem from './views/editbusinessdrinkitem.vue'

import BusinessDrinkList from './views/businessdrinklist.vue'

import Aboutjuzzap from './views/aboutjuzzap.vue'

import BusinessType from './views/BusinessType.vue'

import MenuOption from './views/MenuOption.vue'

import Verifiedemail from './views/varifiedemail.vue'

import Verifiedemailconfirm from './views/Varifiedemailconfirm.vue'

import EmailSend from './views/EmailSend.vue'


Vue.use(Router)

let router= new Router({
  mode:'history',
  base:'/0001/',
  routes: [

    // {
    //   path: '/',
    //   name: 'front',
    //   component: Front
    // },
    {
      path: '/',
      name: 'frontnew',
      component: FrontNew
    },
    {
      path: '/userdashboard/:ukey?',
      name:'userdashboard',
      component:UserDashboard,

    },
    {
      path: '/login',
      name: 'home',
      component: Home
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path:'/registeroption',
      name: 'registeroption',
      component: RegisterOption
    },
    // {
    //   path:'/changepassword',
    //   name:'newchangepassword',
    //   component:NewChangePassword
    // },
    {
      path:'/aboutjuzzap',
      name: 'aboutjuzzap',
      component: Aboutjuzzap
    },
    {
      path:'/businesstype',
      name: 'businesstype',
      component: BusinessType
    },
    {
      path:'/businessregister/:type?',
      name:'businessregister',
      component:BusinessRegister
    },

    {
      path:'/verifiedemail/:emailvarifiedcode',
      name:'verifiedemail',
      component:Verifiedemail
    },

    {
      path:'/verifiedemailconfirm',
      name:'varifiedemailconfirm',
      component:Verifiedemailconfirm
    },

    {
      path:'/emailsend',
      name:'emailsend',
      component:EmailSend
    },

    {
      path: '/businessdashboard',
      name:'businessnewdashboard',
      component:BusinessNewDashboard,

    },

    {
      path: '/menuoption/:id',
      name:'menuoption',
      component:MenuOption,

    },


    // {
    //   path: '/updatebusiness/:id',
    //   name: 'updatebusiness',
    //   component: UpdateBusiness,
    // },
    // {

    //   path:'/businessdrinklist/:id',
    //   name:'businessdrinklist',
    //   component:BusinessDrinkList,
    // },
    // {
    //   path:'/businessfoodlist/:id',
    //   name:'businessfoodlist',
    //   component:BusinessFoodList,
    // },
    // {
    //   path:'/createbusinessdrinkitem/:id',
    //   name:'createbusinessdrinkitem',
    //   component:CreatebusinessdrinkItem,
    // },

    // {
    //   path:'/createfooditem/:id',
    //   name:'createfooditem',
    //   component:CreateFoodItem,
    // },
    // {
    //   path:'/:business_id/editfooditem/:id',
    //   name:'editfooditem',
    //   component:EditFoodItem,
    // },
    // {
    //   path:'/:business_id/editbusinessdrinkitem/:id',
    //   name:'editbusinessdrinkitem',
    //   component:EditBusinessDrinkItem,
    // },


    {
      path: '/agent/createagent',
      name: 'createagent',
      component: CreateAgent,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/agent/agentlist',
      name: 'agentlist',
      component: AgentList,
      meta:{
        requiresAuth:true
      }
    },
    {
      path:'/agent/editagent/:id',
      name:'editagent',
      component:EditAgent,
      meta:{
        requiresAuth:true
      }
    },

    {
      path:'/agent/itemlist/:business_id',
      name:'itemlist',
      component: itemlist,
    },
    {
      path: '/agent/createitem/:business_id',
      name: 'createitem',
      component: createitem,
    },
    {
      path:'/agent/departmentlist/:business_id',
      name:'departmentlist',
      component: departmentlist,
    },
    {
      path: '/agent/createevent/:business_id',
      name: 'createevent',
      component: createevent,
    },
    {
      path:'/agent/eventlist/:business_id',
      name:'eventlist',
      component: eventlist,
    },
    {
      path: '/agent/editevent/:id',
      name: 'editevent',
      component: editevent,
    },
    {
      path: '/agent/createdepartment/:business_id',
      name: 'createdepartment',
      component: createdepartment,
    },
    {
      path:'/agent/employeelist/:business_id',
      name:'employeelist',
      component: employeelist,
    },
    {
      path: '/agent/createemployee/:business_id',
      name: 'createemployee',
      component: createemployee,
    },
    {
      path:'/agent/drinkitemlist/:business_id',
      name:'drinkitemlist',
      component: drinkitemlist,
    },
    {
      path: '/agent/createdrinkitem/:business_id',
      name: 'createdrinkitem',
      component: createdrinkitem,
    },
    {
      path: '/agent/:business_id/editdrinkitem/:id',
      name: 'editdrinkitem',
      component: editdrinkitem,
    },


    {
      path:'/thankyou',
      name:'tankyou',
      component:ThankYou,
    },


    {
      path: '/business/login',
      name: 'business',
      component: Business
    },

    // {
    //   path: '/business/dashboard',
    //   name: 'businessDashboard',
    //   component: Businessdashboard
    // },
    {
      path: '/business/createmeat',
      name: 'createmeat',
      component: creatmeat,
    },
    {
      path:'/business/meatlist',
      name:'meatlist',
      component: meatlist,
    },
    {
      path: '/business/editmeat/:id',
      name: 'editmeat',
      component: meatedit,
    },
    {
      path: '/business/creatediet',
      name: 'creatediet',
      component: creatediet,
    },
    {
      path:'/business/dietlist',
      name:'dietlist',
      component: dietlist,
    },
    {
      path: '/business/editdiet/:id',
      name: 'editddiet',
      component: editdiet,
    },
    {
      path: '/editemployee/:id',
      name: 'editemployee',
      component: editemployee,
    },
    {
      path: '/editdepartment/:id',
      name: 'editdepartment',
      component: editdepartment,
    },

    {
      path: '/agent/:business_id/edititem/:id/',
      name: 'edititem',
      component: edititem,
    },
    // {
    //   path: '/business/createemployee',
    //   name: 'createemployee',
    //   component: createEmployee,
    // },

    {
      path: '/agent',
      name: 'agent',
      component: Agent
    },

    //{
    //    path: '/agent/login',
    //    name: 'agenthome',
    //    component: Home
    //},
    {
      path:'/agent/changepassword',
      name:'changepassword',
      component:ChangePassword
    },

    

    {
      path: '/agent/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta:{
        requiresAuth:true
      }
    },

    {
      path: '/agent/createbusiness',
      name: 'createbusiness',
      component: CreateBusiness,
      meta:{
        requiresAuth:true
      }
    },

    {
      path:'/agent/createbusinessnew',
      name:'createbusinessnew',
      component: CreateBusinessNew,
      meta:{
        requiresAuth:true
      }
    },

    {
      path:'/agent/createbusinesscontactdetail/:business_id',
      name:'createbusinessdetail',
      component: CreateBusinessDetail,
      meta:{
        requiresAuth:true
      }
    },

    {
      path:'/agent/editprofile',
      name:'editprofile',
      component:EditProfile,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/agent/editbusiness/:id',
      name:'editbusiness',
      component:EditBusiness,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/agent/businesslistold',
      name: 'businesslist',
      component: BusinessList,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/agent/businesslist',
      name: 'businesslistnew',
      component: BusinessListNew,
      meta:{
        requiresAuth:true
      }
    },

    {
      path: '/agent/tagslist',
      name: 'tagslist',
      component: tagslist,
      meta:{
        requiresAuth:true
      }
    },

    // {
    //   path: '/agent/createretailitem/:business_id',
    //   name: 'createretailitem',
    //   component: createretailitem,
    // },

    // {
    //   path: '/agent/editretailitem/:id',
    //   name: 'editretailitem',
    //   component: editretailitem,
    // },

    // {
    //   path:'/agent/retailitemlist/:business_id',
    //   name:'retailitemlist',
    //   component: retailitemlist,
    // },

    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },

    // {
    //   path: '/teams/:id',
    //   name:'teams',
    //   component:teams,
    // },
    {
      path: '/teamdetails/:id',
      name:'teamdetails',
      component:teamdetails,
    },
    // {
    //   path: '/eventdetails/:id/:businessid',
    //   name:'eventdetails',
    //   component:eventdetails,
    // },
    // {
    //   path: '/events/:id',
    //   name:'events',
    //   component:events,
    // },
    // {
    //   path: '/businessDetails/:id',
    //   name:'businessDetails',
    //   component:businessDetails,
    // },
    {
      path: '/businessDetails/:tag',
      // name:'businessDetails',
      component:businessDetails,
      children:[
        

        {'path':'',component:bDetails,name:'bDetails'},
        {'path':'retailitem',component:retailitem,name:'retailitem'},
        {'path':'events',component:events,name:'events'},
        {'path':'team',component:teams,name:'team'},
        {'path':'love',component:businesslove,name:'love'},
        {'path':'food',component:food,name:'food'},
        {'path':'drink',component:drink,name:'drink'},
        {'path':'order',component:order,name:'order'},
        {'path':'fooditemdetails/:fooditemid/:courseid',component:fooditemdetails,name:'fooditemdetails'},
        {'path':'eventdetail/:eventid',component:eventdetails,name:'eventdetail'},
        {'path':'teamdetail/:teamid',component:teamdetails,name:'teamdetail'},
        {'path':'coronasurvey',component:coronasurvey,name:'coronasurvey'},
        {'path':'coronafeedback',component:coronafeedback,name:'coronafeedback'},
        {'path':'health',component:health,name:'health'},
        {'path':'emergency',component:emergency,name:'emergency'},
        {'path':'symptoms',component:symptoms,name:'symptoms'},
        {'path':'healthadvice',component:healthadvice,name:'healthadvice'},
        {'path':'languagecode',component:Languagecode,name:'languagecode'},


      ]
    },
    {
      path: '/business',
      // name:'businessDetails',
      component:BusinessNewDashboard,
      children:[
        //{'path':'food',component:food,name:'food'},

        {'path':'changepass',component:changepass,name:'changepass'},
        {'path':'',component:DashboardBusiness,name:'dashboardbusiness'},
        {'path':'apphelp',component:AppHelp,name:'apphelp'},
        {'path':'profile',component:UpdateBusiness,name:'updatebusiness'},
        {'path':'businessstatics',component:businessstatics,name:'businessstatics'},
        {'path':'food',component:BusinessFoodList,name:'businessfoodlist'},
        {'path':'foodlist',component:BusinessFoodItemList,name:'businessfooditemlist'},

        {'path':'TypeList',component:TypeList,name:'typelist'},


        {'path':'editfooditem/:id',component:EditFoodItem,name:'editfooditem'},
        {'path':'CategoryList',component:CategoryList,name:'categorylist'},
        {'path':'addDepartment',component:addDepartment,name:'addDepartment'},
        {'path':'addEmployee',component:addEmployee,name:'addEmployee'},
        {'path':'editemployee/:id',component:updateemployee,name:'editemployees'},

        {'path':'CreateEventCategory',component:CreateEventCategory,name:'createeventcategory'},
        {'path':'EventCategoryList',component:EventCategoryList,name:'eventcategorylist'},
        {'path':'EditEventCategory/:id',component:EditEventCategory,name:'editeventcategory'},
        {'path':'addEvent',component:addEvent,name:'addEvent'},
        {'path':'eventList',component:eventLists,name:'eventLists'},
        {'path':'editevent/:id',component:updateevent,name:'editevents'},

        {'path':'EditType/:id',component:EditType,name:'edittype'},


        {'path':'employeeList',component:employeeLists,name:'employeeLists'},
        {'path':'editdepartment/:id',component:updatedepartment,name:'editdepartments'},
        {'path':'departmentlist',component:departmentlists,name:'departmentlists'},
        {'path':'CreateCategory',component:CreateCategory,name:'createcategory'},
        {'path':'EditCategory/:id',component:EditCategory,name:'editcategory'},
        {'path':'CreateRetailItem',component:CreateRetailItem,name:'createretailitem'},
        {'path':'RetailItemlist',component:RetailItemlist,name:'retailitemlist'},
        {'path':'Retaillist',component:Retaillist,name:'retaillist'},

        {'path':'EditRetailItem/:id',component:EditRetailItem,name:'editretailitem'},
        {'path':'CreateFoodItem',component:CreateFoodItem,name:'createfooditem'},
        {'path':'createbusinessdrinkitem',component:CreatebusinessdrinkItem,name:'createbusinessdrinkitem'},
        
        {'path':'drink',component:BusinessDrinkList,name:'businessdrinklist'},
        {'path':'drinkdrag',component:DrinkDragDropList,name:'drinkdragdroplist'},

        { 'path':'editbusinessdrinkitem/:id',component:EditBusinessDrinkItem,name:'editbusinessdrinkitem'},
        {'path':'createcourse',component:createcourse,name:'createcourse'},
        {'path':'createtype',component:createtype,name:'createtype'},

        {'path':'courselist',component:courselist,name:'courselist'},

        { 'path':'editcourse/:id',component:editcourse,name:'editcourse'},
        

        
      ]
    },
    {
      path: '/businesslove/:id',
      name:'businesslove',
      component:businesslove,
    },
    // {
    //   path: '/:code',
    //   name:'home',
    //   component:Home,

    // },


    // {
    //   path: '/:code',
    //   name:'tags',
    //   component:Tags,

    // },

    {
      path: '/:code/login',
      name:'blogin',
      component:Home,

    },

    {
      path: '/:code/register',
      name:'bregister',
      component:Register,

    },

    {
      path: '/:code/home/:type?',
      name:'businesshome',
      component:BusinessHome,

    },



    {
      path: '/:code',
      name:'tagsnew',
      component:TagsNew,

    },

    // {
    //   path: '/login',
    //   name: 'home',
    //   component: Home
    // },
    // {
    //   path: '/0002/businessdetails/:id',
    //   name:'businessDetails',
    //   component:businessDetails,
    // },
    // {
    //   path: '/0002/businesslove/:id',
    //   name:'businesslove',
    //   component:businesslove,
    // },
    // {
    //   path: '/0002/:code',
    //   name:'tagsnew',
    //   component:TagsNew,

    // },
  ]
});
router.beforeEach((to,from,next)=>{
  if(to.matched.some(record=>record.meta.requiresAuth)){
    if(store.getters.user && JSON.parse(store.getters.user).userType=='agent'){
      next()
      return
    }
    next('/');
  }else{
    next()
  }
});

export default router
